const fromdata = [
  {
    inputdata: "",
    title: "产品编码",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "input",
    width: "400px",
    disabled: false,
    lablewith: "100px",
    inputflag: false,
  },
  {
    inputdata: "",
    title: "产品代码",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "input",
    width: "400px",
    lablewith: "95px",
  },
  {
    inputdata: "",
    title: "标准货值",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "",
    inputtype: "numberINV",
    width: "410px",
    lablewith: "100px",
  },
  {
    inputdata: "",
    title: "启效日期",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "dates",
    widths: "410px",
    disabled: false,
    lablewith: "100px",
    options: [],
  }
];
export default fromdata;
